import React from "react";
import Lottie from "react-lottie";
import { useTranslations } from "@jugl-web/utils";
import { useKnowledgeTraining } from "@web-src/modules/cx/providers/KnowledgeTrainingProvider";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useAgentKnowledge } from "@web-src/modules/cx/hooks/useAgentKnowledge";
import retrainingAnimation from "./assets/retraining.json";

export const BlockingOverlayLoader: React.FC = () => {
  const { t } = useTranslations();
  const { trainingStatus } = useKnowledgeTraining();
  const { entityId } = useEntitySelectedProvider();
  const { knowledgeInfo } = useAgentKnowledge(entityId);

  if (trainingStatus !== "in_process") return null;
  return (
    <div
      className="absolute inset-0 z-10 flex w-full flex-col items-center justify-center bg-white/90"
      onClick={(e) => e.preventDefault()}
      onMouseDown={(e) => e.preventDefault()}
    >
      <Lottie
        options={{ animationData: retrainingAnimation }}
        width={150}
        height={150}
        isClickToPauseDisabled
      />
      <span className="mt-6 font-secondary text-[22px] leading-[33px] font-medium text-black">
        {!knowledgeInfo?.info.last_updated
          ? t({
              id: "cx-ai-agents-page.training-in-progress",
              defaultMessage: "Training in Progress",
            })
          : t({
              id: "cx-ai-agents-page.retraining-in-progress",
              defaultMessage: "Retraining in Progress",
            })}
      </span>
      <span className="mt-1.5 font-secondary text-sm leading-[21px] text-[#737B7E]">
        {t({
          id: "cx-ai-agents-page.please-wait-ai-agent-smarter",
          defaultMessage: "Please wait a moment, AI Agent getting smarter",
        })}
      </span>
    </div>
  );
};
